var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4022 9.53906C24.0546 9.53906 19.8045 10.8283 16.1895 13.2438C12.5745 15.6592 9.75702 19.0924 8.09324 23.1091C6.42945 27.1259 5.99412 31.5457 6.84231 35.8099C7.69052 40.0739 9.78412 43.9908 12.8584 47.0652C15.9327 50.1395 19.8496 52.233 24.1137 53.0813C28.3778 53.9293 32.7978 53.4941 36.8144 51.8304C40.8312 50.1665 44.2643 47.349 46.6798 43.734C49.0952 40.1192 50.3845 35.8691 50.3845 31.5214C50.3776 25.6934 48.0596 20.1061 43.9385 15.9851C39.8174 11.8641 34.2302 9.54594 28.4022 9.53906ZM35.8102 38.9294C35.4355 39.3041 34.9274 39.5145 34.3975 39.5145C33.8675 39.5145 33.3593 39.3041 32.9845 38.9294L26.9894 32.9342C26.6146 32.5595 26.404 32.0513 26.4038 31.5214V19.531C26.4038 19.001 26.6144 18.4927 26.9892 18.1179C27.3639 17.7432 27.8722 17.5326 28.4022 17.5326C28.9323 17.5326 29.4406 17.7432 29.8153 18.1179C30.1901 18.4927 30.4006 19.001 30.4006 19.531V30.694L35.8102 36.1037C36.1849 36.4784 36.3953 36.9866 36.3953 37.5165C36.3953 38.0463 36.1849 38.5547 35.8102 38.9294Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiPassport);
export default __webpack_public_path__ + "static/media/mdi_passport.f9eecf279e80c7761be3c30551b69fd5.svg";
export { ForwardRef as ReactComponent };